module.exports = __webpack_public_path__ + "img/a1ef276.jpg";